import { render, staticRenderFns } from "./ExemptionCreate.vue?vue&type=template&id=c0b7c002&"
import script from "./ExemptionCreate.vue?vue&type=script&lang=js&"
export * from "./ExemptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports